import { createFileRoute } from '@tanstack/react-router';
import { Stack } from '@osd/ui/stack';
import { Text } from '@osd/ui/text';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/text — live docs for the `Text` primitive.
 */
export const Route = createFileRoute('/ui/_layout/text')({
  component: TextPage,
});

function TextPage() {
  return (
    <Stack gap={6}>
      <Section title="Text" hint="paragraph primitive — default, muted, inline variants">
        <Stack gap={2}>
          <Text>Default text — body copy at base size.</Text>
          <Text muted>Muted text — secondary information, hints, captions.</Text>
          <Text inline>Inline text — sits</Text>
          <Text inline>alongside other content.</Text>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Default — body copy"
            language="tsx"
            code={`<Text>Welcome back. Here's what's new this week.</Text>`}
          />

          <CodeBlock
            title="Muted — secondary text"
            language="tsx"
            code={`<Text muted>Last login: 2 hours ago</Text>`}
          />

          <CodeBlock
            title="Inline — flows inside a paragraph"
            language="tsx"
            code={`<Text>
  Read the <Text as="a" href="/docs" inline>docs</Text> for details.
</Text>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
